import { lazy } from "react";
import { Navigate } from "react-router-dom";

const AccountDetailsPage = lazy(() =>
  import("pages/account/AccountDetailsPage")
);

const AdminPresetListPage = lazy(() =>
  import("pages/presets/AdminPresetListPage")
);
const AdminPresetCreatePage = lazy(() =>
  import("pages/presets/AdminPresetCreatePage")
);
const AdminPresetDetailsPage = lazy(() =>
  import("pages/presets/AdminPresetDetailsPage")
);
const AdminPresetEditPage = lazy(() =>
  import("pages/presets/AdminPresetEditPage")
);

const AdminPresetTypeDetailsPage = lazy(() =>
  import("pages/presets/AdminPresetTypeDetailsPage")
);
const AdminPresetTypeCreatePage = lazy(() =>
  import("pages/presets/AdminPresetTypeCreatePage")
);
const AdminPresetTypeEditPage = lazy(() =>
  import("pages/presets/AdminPresetTypeEditPage")
);

const AdminUserListPage = lazy(() => import("pages/users/AdminUserListPage"));
const AdminUserCreatePage = lazy(() =>
  import("pages/users/AdminUserCreatePage")
);
const AdminUserDetailsPage = lazy(() =>
  import("pages/users/AdminUserDetailsPage")
);
const AdminUserUpdatePage = lazy(() =>
  import("pages/users/AdminUserUpdatePage")
);
const AdminUserSubscriptionManagementPage = lazy(() =>
  import("pages/users/AdminUserSubscriptionManagementPage")
);

const VenueCreatePage = lazy(() => import("pages/venues/VenueCreatePage"));
const VenueDetailsPage = lazy(() => import("pages/venues/VenueDetailsPage"));
const VenueEditPage = lazy(() => import("pages/venues/VenueEditPage"));
const VenueListPage = lazy(() => import("pages/venues/VenueListPage"));

const AdminDeviceListPage = lazy(() =>
  import("pages/devices/AdminDeviceListPage")
);
const AdminDeviceDetailsPage = lazy(() =>
  import("pages/devices/AdminDeviceDetailsPage")
);

const AdminEventListPage = lazy(() =>
  import("pages/events/AdminEventListPage")
);
const AdminEventDetailsPage = lazy(() =>
  import("pages/events/AdminEventDetailsPage")
);
const AdminEventEditPage = lazy(() =>
  import("pages/events/AdminEventEditPage")
);

const AdminEventDeviceDetailsPage = lazy(() =>
  import("pages/eventDevice/AdminEventDeviceDetailsPage")
);
const AdminEventDeviceLiveStreamPage = lazy(() =>
  import("pages/eventDevice/AdminEventDeviceLiveStreamPage")
);
const AdminEventDeviceTelemetrySummaryPage = lazy(() =>
  import("pages/eventDevice/AdminEventDeviceTelemetrySummaryPage")
);

const AdminExportListPage = lazy(() =>
  import("pages/exports/AdminExportListPage")
);
const AdminImportListPage = lazy(() =>
  import("pages/imports/AdminImportListPage")
);
const AdminImportDetailsPage = lazy(() =>
  import("pages/imports/AdminImportDetailsPage")
);

const AdminHomePage = lazy(() => import("pages/admin/AdminHomePage"));
const PublicVenueExportPage = lazy(() =>
  import("pages/admin/PublicVenueExportPage")
);
const AdminFeatureFlagsPage = lazy(() =>
  import("pages/admin/AdminFeatureFlagsPage")
);
const AdminPolicyListPage = lazy(() =>
  import("pages/admin/AdminPolicyListPage")
);
const AdminPolicyCreatePage = lazy(() =>
  import("pages/admin/AdminPolicyCreatePage")
);
const AdminPolicyEditPage = lazy(() =>
  import("pages/admin/AdminPolicyEditPage")
);
const AdminLegalEntityPage = lazy(() =>
  import("pages/admin/AdminLegalEntityPage")
);

export default [
  {
    path: "",
    element: <Navigate to="home" />,
  },
  //
  // Home
  {
    path: "home",
    element: <AdminHomePage />,
  },
  {
    path: "public-venue-export",
    element: <PublicVenueExportPage />,
  },
  {
    path: "feature-flags",
    element: <AdminFeatureFlagsPage />,
  },
  //
  // Privacy management
  {
    path: "policies",
    element: <AdminPolicyListPage />,
  },
  {
    path: "policies/create",
    element: <AdminPolicyCreatePage />,
  },
  {
    path: "policies/legal-entity",
    element: <AdminLegalEntityPage />,
  },
  {
    path: "policies/:id/edit",
    element: <AdminPolicyEditPage />,
  },
  //
  // Presets
  {
    path: "presets",
    element: <AdminPresetListPage />,
  },
  {
    path: "presets/create",
    element: <AdminPresetCreatePage />,
  },
  {
    path: "presets/:id",
    element: <AdminPresetDetailsPage />,
  },
  {
    path: "presets/:id/edit",
    element: <AdminPresetEditPage />,
  },
  // Preset types
  {
    path: "presetTypes/create",
    element: <AdminPresetTypeCreatePage />,
  },
  {
    path: "presetTypes/:id",
    element: <AdminPresetTypeDetailsPage />,
  },
  {
    path: "presetTypes/:id/edit",
    element: <AdminPresetTypeEditPage />,
  },
  //
  // Users
  {
    path: "users",
    element: <AdminUserListPage />,
  },
  {
    path: "users/create",
    element: <AdminUserCreatePage />,
  },
  {
    path: "users/:id",
    element: <AdminUserDetailsPage />,
  },
  {
    path: "users/:id/edit",
    element: <AdminUserUpdatePage />,
  },
  {
    path: "users/:id/subscription",
    element: <AdminUserSubscriptionManagementPage />,
  },
  //
  // Accounts
  {
    path: "accounts/:id",
    element: <AccountDetailsPage />,
  },
  //
  // Venues
  {
    path: "venues",
    element: <VenueListPage />,
  },
  {
    path: "venues/create",
    element: <VenueCreatePage />,
  },
  {
    path: "venues/:id",
    element: <VenueDetailsPage />,
  },
  {
    path: "venues/:id/edit",
    element: <VenueEditPage />,
  },
  //
  // Devices
  {
    path: "devices",
    element: <AdminDeviceListPage />,
  },
  {
    path: "devices/:id",
    element: <AdminDeviceDetailsPage />,
  },
  // Events
  {
    path: "events",
    element: <AdminEventListPage />,
  },
  {
    path: "events/:id",
    element: <AdminEventDetailsPage />,
  },
  {
    path: "events/:id/edit",
    element: <AdminEventEditPage />,
  },
  // EventDevices
  {
    path: "eventDevices/:id",
    element: <AdminEventDeviceDetailsPage />,
  },
  {
    path: "eventDevices/:id/liveStream",
    element: <AdminEventDeviceLiveStreamPage />,
  },
  {
    path: "eventDevices/:id/telemetrySummary",
    element: <AdminEventDeviceTelemetrySummaryPage />,
  },
  // Imports
  {
    path: "/admin/imports",
    element: <AdminImportListPage />,
  },
  {
    path: "/admin/imports/:id",
    element: <AdminImportDetailsPage />,
  },
  {
    path: "/admin/exports",
    element: <AdminExportListPage />,
  },
];
